export default "__VITE_ASSET__CMBaRjfA__"